import { useState } from "react";
import React from "react";
import { h2 } from "../../ui/typography/typography.module.css";
import ClientsSlider from "@components/home/clients/clients-slider";
import ScheduleButton from "@components/ui/schedule-button";
import { graphql, useStaticQuery } from "gatsby";
import Button from "@/components/ui/button";
import Modal from "@components/ui/modal";
import ContactForm from "@components/contact/contact-form";

interface ClientSliderCtaProps extends React.HTMLProps<HTMLDivElement> {
  title?: string;
  ctaText?: string;
}
interface SliderContent {
  clientSliderCtaText: string;
}
interface SliderPageContent {
  allStrapiPageContent: {
    nodes: SliderContent[];
  };
}

const ClientSliderCta: React.FC<ClientSliderCtaProps> = ({
  title = "Join 63+ global companies on your long-term business growth.",
  ctaText = "Book a 15-min chat"
}) => {
  const result: SliderPageContent = useStaticQuery(graphql`
    query editableContentSlider {
      allStrapiPageContent {
        nodes {
          clientSliderCtaText
        }
      }
    }
  `);

  const data = result.allStrapiPageContent.nodes;
  const [isModalOpen, setIsModalOpen] = useState(false);
  const openModal = () => setIsModalOpen(!isModalOpen);

  return (
    <>
      {data.map((result, index) => (
        <section className="mt-24 pt-2 md:pt-0 md:mt-52" key={index}>
          <h3 className={`${h2} md:text-center max-w-4xl mx-auto`}>{title}</h3>
          <ClientsSlider className="mt-16 -mx-6" />
          <div className="md:text-center">
             <div className="mt-8 md:mt-10 flex flex-col md:flex-row md:gap-6 justify-center">
            <ScheduleButton variant="primary">{ctaText}</ScheduleButton>
            <Button
              variant="outline"
              className="block w-full mt-6 md:mt-0 md:inline-block md:w-auto"
              size="lg"
              onClick={openModal}
            >
              Write us
            </Button>
          </div>
          </div>
          <Modal open={isModalOpen} closeModal={() => setIsModalOpen(false)}>
            <ContactForm callBack={() => setIsModalOpen(false)} />
          </Modal>
        </section>
      ))}
    </>
  );
};

export default ClientSliderCta;
